import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { openModal } from 'reducers/modalReducer';
import { getBrLockStatus } from 'services/businessRelationService';
import { LockType } from 'types/PartnerLockTypes';
import { isNotNullOrUndefined } from 'utils/utils';

type LockContext = {
  userId: string;
};

export type BrLockType = {
  busRelUid: string;
  lockType: LockType;
  lockContext: LockContext;
};

export const useFetchBrLock = (techId?: string) => {
  const dispatch = useDispatch();

  const query = useQuery<BrLockType[], AxiosError>({
    queryKey: ['fetchBrLock', techId],
    queryFn: () => getBrLockStatus(techId),
    enabled: isNotNullOrUndefined(techId),
  });

  useEffect(() => {
    if (isNotNullOrUndefined(query.error) && query.error.response?.status !== 403) {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: 'Error fetching br lock from br-mgmt',
              title: 'Error fetching br lock',
              userErrorMessage: 'An error occurred when fetching br lock data',
            },
            httpError: query.error,
          },
        }),
      );
    }
  }, [query.error, dispatch]);

  return query;
};
